const colors = {
  Admiration: "#FFD700", // Gold
  Adoration: "#FF69B4", // Hot Pink
  "Aesthetic Appreciation": "#00FFFF", // Cyan
  Amusement: "#FF6347", // Tomato
  Anger: "#FF0000", // Red
  Annoyance: "#FFFF00", // Yellow
  Anxiety: "#1E90FF", // Dodger Blue
  Awe: "#9370DB", // Medium Purple
  Awkwardness: "#FFD700", // Gold
  Boredom: "#808080", // Gray
  Calmness: "#20B2AA", // Light Sea Green
  Concentration: "#32CD32", // Lime Green
  Confusion: "#D3D3D3", // Light Gray
  Contemplation: "#DDA0DD", // Plum
  Contempt: "#8B4513", // Saddle Brown
  Contentment: "#008000", // Green
  Craving: "#CD853F", // Peru
  Desire: "#FF4500", // Orange Red
  Determination: "#8A2BE2", // Blue Violet
  Disappointment: "#800000", // Maroon
  Disapproval: "#696969", // Dim Gray
  Disgust: "#B22222", // Fire Brick
  Distress: "#DC143C", // Crimson
  Doubt: "#708090", // Slate Gray
  Ecstasy: "#FF69B4", // Hot Pink
  Embarrassment: "#FFD700", // Gold
  "Empathic Pain": "#800000", // Maroon
  Enthusiasm: "#FFD700", // Gold
  Entrancement: "#FFD700", // Gold
  Envy: "#008000", // Green
  Excitement: "#FF4500", // Orange Red
  Fear: "#FF8C00", // Dark Orange
  Gratitude: "#FFD700", // Gold
  Guilt: "#800000", // Maroon
  Horror: "#000000", // Black
  Interest: "#FFD700", // Gold
  Joy: "#FFFF00", // Yellow
  Love: "#FF69B4", // Hot Pink
  Nostalgia: "#F4A460", // Sandy Brown
  Pain: "#800000", // Maroon
  Pride: "#FFD700", // Gold
  Realization: "#FFD700", // Gold
  Relief: "#32CD32", // Lime Green
  Romance: "#FF1493", // Deep Pink
  Sadness: "#0000FF", // Blue
  Sarcasm: "#808080", // Gray
  Satisfaction: "#FFD700", // Gold
  Shame: "#FFD700", // Gold
  "Surprise (negative)": "#9370DB", // Medium Purple
  "Surprise (positive)": "#9370DB", // Medium Purple
  Sympathy: "#FFD700", // Gold
  Tiredness: "#808080", // Gray
  Triumph: "#FFD700", // Gold
};

export default colors;
